import React from "react";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";

import PageSize from "components/SelectedFilters/PageSize";

import "./style.scss";

const TableDictionary = ({
  loading = false,
  setCurrentPage,
  currentPage,
  totalPages,
  pageSize,
  setPageSize,
  data = [],
  onViewDetail,
}) => {
  const columns = [
    {
      Header: "Name",
      accessor: "name",
      Cell: ({ value }) => (
        <div className="table-text-color dictionary-name">{value}</div>
      ),
      sortable: true,
    },
    {
      Header: "Type",
      accessor: "type",
      Cell: ({ value }) => (
        <span
          className={`table-text-color dictionary-type ${value.toLowerCase()}`}>
          {value}
        </span>
      ),
      sortable: true,
      width: 120,
    },
    {
      Header: "Creation Date",
      accessor: "createdDate",
      Cell: ({ value }) => (
        <div className="table-text-color dictionary-date">
          {value ? new Date(value).toLocaleDateString("it-IT") : "-"}
        </div>
      ),
      sortable: true,
      width: 130,
    },
    {
      Header: "Last Update",
      accessor: "lastModifiedDate",
      Cell: ({ value }) => (
        <div className="table-text-color dictionary-date">
          {value ? new Date(value).toLocaleDateString("it-IT") : "-"}
        </div>
      ),
      sortable: true,
      width: 130,
    },
    {
      id: "actions",
      Header: "Actions",
      accessor: d => d,
      Cell: ({ value }) => (
        <button
          className="detail-button"
          onClick={() => onViewDetail && onViewDetail(value)}
          title={`View details for ${value.name}`}>
          View Details
        </button>
      ),
      minWidth: 100,
      sortable: false,
    },
  ];

  return (
    <div className="table-container">
      <div className="pre-header-data">
        <PageSize
          pageSize={pageSize}
          setPageSize={setPageSize}
          entityType="dictionaries"
        />
      </div>
      <ReactTable
        data={data}
        columns={columns}
        minRows={1}
        showPageSizeOptions={false}
        showPageJump={false}
        pageSize={pageSize}
        collapseOnPageChange={false}
        PadRowComponent={() => null}
        noDataText="No dictionary found"
        loading={loading}
        sortable={false}
        page={currentPage}
        pages={totalPages}
        onPageChange={pageIndex => {
          setCurrentPage(pageIndex);
        }}
      />
    </div>
  );
};

export default TableDictionary;
